<template>
  <div class="memberList">
    <v-card class="cardWrap">
      <CardTitle title="ChatBox" />
      <v-data-table
        :headers="headers"
        :items="desserts"
        hide-default-footer
        class="elevation-1"
        sort-by="memberNo">
        <template v-slot:top>
        <v-form ref="form" lazy-validation>
          <v-toolbar flat color="white" class="mt-1">
                <v-text-field
                    class="mr-3 pt-4"
                    v-model="search"
                    append-icon="mdi-account-search"
                    label="氏名"
                />
                <!-- <v-select
                    class="mr-3 selectWidth pt-4"
                    :items="Itemlist"
                    item-value="golf_code"
                    item-text="golf_name"
                    v-model="golf_code"
                    label="ゴルフ場を選択"
                    v-if="modeStatus === 'user_div'"
                    :rules="[rules.required_golf_course]"
                ></v-select> -->
                ステータス：<v-radio-group
                    class="status_radio float-right"
                    v-model="searchOption"
                    row>
                    <v-radio
                        class="pt-4"
                        v-for="d in searchOptionList"
                        :key="d.id"
                        :label="d.code_name"
                        :value="d.code" />
                </v-radio-group>
                表示順：<v-radio-group
                    v-model="sortOption"
                    row>
                    <v-radio
                        class="pt-4"
                        v-for="d in sortOptionList"
                        :key="d.id"
                        :label="d.code_name"
                        :value="d.code" />
                </v-radio-group>
                <v-spacer></v-spacer>
                <!-- <v-checkbox
                    class="mr-3 selectWidth pt-4"
                    v-model="completed"
                    label="未返信メッセージあり"
                /> -->

            <v-btn
                class="mr-2"
                color="primary"
                v-on:click="clickSearch"
                :disabled="btn[0].isActive"
                >検索
            </v-btn>
          </v-toolbar>
        </v-form>
        </template>
        <template v-slot:[`item.message`]="{ item }">
          <v-icon
            :disabled="btn[1].isActive"
            @click="MessageListOpen(item)">mdi-message-text-outline</v-icon>
        </template>
        <template v-slot:[`item.completed_name`]="{ item }">
          <span :class="getColor(item)">{{ item.completed_name }}</span>
        </template>
      </v-data-table>
      <v-pagination
        class="my-2"
        v-model="page"
        :length="pageCount"
        :total-visible="7"
        @input="clickPagination"
      ></v-pagination>
    </v-card>
    <!-- <MemberModal ref="MemberAddView" @refresh-event="getMessageList"/>
    <MemberCard ref="MemberCardView" @refresh-event="getMessageList" :golfCourseSelection="Itemlist" :golfCourseInput="golf_code"/>
    <MemberClassfication ref="MemberClassficationView" @refresh-event="getMessageList" :golfCourseSelection="Itemlist" :golfCourseInput="golf_code"/>
    <MemberPointHistoryModal ref="PointHistoryView" @refresh-event="getMessageList" :adminInfo="admin" :golfGroupInfo="golf_groups" :golfCourseInput="golf_code"/> -->
    <MessageList ref="MessageView" @refresh-event="getMessageList" :adminInfo="admin" :received="passTo" :golfCourseSelection="Itemlist" :code="codeList"/>
  </div>
</template>

<script>
import CardTitle from '../../components/module/CardTitle';
// import MemberModal from './modal/Member';
// import MemberCard from './modal/MemberCard';
// import MemberClassfication from './modal/MemberClassfication';
// import MemberPointHistoryModal from './modal/MemberPointHistory';
import MessageList from './../Message/MessageList';
// import validater from '@/lib/validater';

// import { CODE_MASTER } from '../config';
// サンプルデータ（ポイント残数）
// import SamplePointData from '../../assets/data/sample_point.json';

import { GET_ALL_CONTACT_MESSAGE_LIST, GET_CHATBOX_DATA } from '../../constants/contact';

export default {
    components: {
        CardTitle,
        // MemberModal,
        // MemberCard,
        // MemberClassfication,
        // MemberPointHistoryModal,
        MessageList
    },
    props: ['name'],
    data () {
        return {
            page: 1,
            pageCount: 0,
            // 検索キーワード
            search: '',
            inputName: '',
            // コードマスタ
            codeList: [],
            searchOptionList: [],
            searchOption: 9,
            inputSearchOption: null,
            sortOptionList: [
                { id: 1, code_name: 'ステータス順', code: 1 },
                { id: 2, code_name: '会員番号順', code: 2 }
            ],
            sortOption: 1,
            inputSortOption: null,
            Itemlist: [],
            // データテーブルに渡す値
            desserts: [],
            // データテーブルの見出し要素
            headers: [
                { text: '会員No', sortable: false, value: 'member_no' },
                { text: '氏名', align: 'left', sortable: false, value: 'name' },
                { text: '会員区分', align: 'left', sortable: false, value: 'code_name' },
                { text: 'メッセージ', align: 'center', value: 'message', sortable: false },
                { text: '送受信日', value: 'created_at', sortable: false },
                { text: 'ステータス', value: 'completed_name', sortable: false }
            ],
            // 区分選択のセレクトエリアの表示値
            golf_groups: [],
            // ゴルフ場選択の制御
            modeStatus: '',
            golf_code: null,
            begin_row: 0,
            limit_rows: 10,
            golfSelect: [],
            // メッセージ画面に渡す情報
            passTo: {
                golfCode: '',
                reserve_no: ''
            },
            // ログインしている者の情報
            admin: {
                golf_code: '',
                user_div: '',
                user_id: '',
                point_use_type: ''
            },
            // ボタンの活性・非活性
            btn: [
                { element_id: '001', element_name: '検索', isActive: true },
                { element_id: '002', element_name: 'メッセージ表示', isActive: true }
            ],
            vue_id: 'SCR0106',
            rules: {
                required_golf_course: value => this.isRequired(value) || this.$t('error.validation.required.whenCardNoIs')
            },
            loadingCount: 0
        };
    },
    async created () {
        this.loadingOn();
        this.inputName = this.search;
        this.inputSearchOption = this.searchOption;
        this.inputSortOption = this.sortOption;
        this.initialize();
        this.loadingOff();
    },
    computed: {
        // formatedDate: function () {
        //     return function (pdate) {
        //         pdate = this.addHyphen(pdate);
        //         return pdate;
        //     };
        // }
    },
    methods: {
        async initialize () {
            this.loadingOn();
            this.passTo.reserve_no = '';
            this.passTo.golfCode = '';
            try {
                await this.$apollo.query({
                    query: GET_CHATBOX_DATA,
                    variables: {
                        golf_group_code: process.env.VUE_APP_GROUP_CODE,
                        vue_id: this.vue_id,
                        element_id: '',
                        name: this.inputName,
                        completed: this.inputSearchOption,
                        sort_option: this.inputSortOption,
                        begin_row: this.begin_row,
                        limit_rows: this.limit_rows
                    }
                }).then(res => {
                    // コードマスタより対応完了フラグの名称を取得
                    this.codeList = res.data.getChatBoxData.codeList;
                    this.searchOptionList = [
                        { id: 1, code_name: this.codeList[0].code_name, code: 0 },
                        { id: 2, code_name: this.codeList[1].code_name, code: 1 },
                        { id: 3, code_name: '全て', code: 9 }
                    ];
                    var adminInfo = res.data.getChatBoxData.adminInfo;
                    this.admin.user_id = adminInfo.user_id;
                    this.admin.user_div = adminInfo.user_div;
                    this.admin.golf_code = adminInfo.golf_code;
                    this.admin.point_use_type = adminInfo.point_use_type;
                    this.Itemlist = res.data.getChatBoxData.ItemList;
                    this.golf_code = res.data.getChatBoxData.golf_code;
                    const count = res.data.getChatBoxData.count;
                    this.pageCount = Math.ceil(count / this.limit_rows);
                    this.desserts = [];
                    if (!count) return;
                    this.modeStatus = 'user_div';
                    this.desserts = res.data.getChatBoxData.MemberMessage;
                    this.desserts.forEach(el => {
                        el.name = el.family_name + ' ' + el.given_name;
                    });
                    let opeList = res.data.getChatBoxData.OperationAccessList;
                    for (let list of opeList) {
                        this.btn.forEach(el => {
                            if (list.element_id === el.element_id) {
                                if (list.element_control === 0) {
                                    el.isActive = true;
                                } else {
                                    el.isActive = false;
                                }
                            }
                        });
                    };
                });
                this.loadingOff();
            } catch (error) {
                this.error = error;
                this.loadingOff();
            }
        },
        /** --------------------------------------------
        * メッセージ一覧取得
        * -------------------------------------------- */
        async getMessageList () {
            this.loadingOn();
            this.passTo.reserve_no = '';
            this.passTo.golfCode = '';
            try {
                await this.$apollo
                    .mutate({
                        fetchPolicy: 'no-cache',
                        mutation: GET_ALL_CONTACT_MESSAGE_LIST,
                        variables: {
                            name: this.inputName,
                            completed: this.inputSearchOption,
                            sort_option: this.inputSortOption,
                            golf_group_code: process.env.VUE_APP_GROUP_CODE,
                            golf_code: this.golf_code,
                            begin_row: this.begin_row,
                            limit_rows: this.limit_rows
                        }
                    })
                    .then(res => {
                        const count = res.data.getAllMemberContactsMessageList.count;
                        this.pageCount = Math.ceil(count / this.limit_rows);
                        this.desserts = [];
                        if (!count) return;
                        this.modeStatus = 'user_div';
                        this.desserts = res.data.getAllMemberContactsMessageList.MemberMessage;
                        this.desserts.forEach(el => {
                            el.name = el.family_name + ' ' + el.given_name;
                        });
                    });
                this.loadingOff();
                this.$store.commit('loading/setIsLoading', false);
            } catch (error) {
                this.error = error;
                this.loadingOff();
            }
        },
        isRequired (value) {
            if (this.card_no) {
                if (value) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return true;
            }
        },
        /** ----------------------------------------------
        * メッセージボタン押下時の処理
        * @val 子画面に渡すモーダル表示制御値
        * @item 押下した行の情報
        * ---------------------------------------------- */
        MessageListOpen: function (item) {
            this.passTo.reserve_no = item.reserve_no === '000000000000' || !item.reserve_no ? '' : item.reserve_no;
            this.passTo.golfCode = item.golf_code ? item.golf_code : this.golf_code;
            this.$refs.MessageView.ModalControl(item.member_no);
        },
        clickPagination: function () {
            this.begin_row = this.page * this.limit_rows - this.limit_rows;
            this.getMessageList();
        },
        clickSearch: function () {
            this.inputName = this.search;
            this.inputSearchOption = this.searchOption;
            this.inputSortOption = this.sortOption;
            this.page = 1;
            this.begin_row = 0;
            this.getMessageList();
        },
        /** --------------------------------------------
         * ポイントがマイナス時のCSS切り替え
         * -------------------------------------------- */
        getColor (el) {
            if (el.completed === 0) {
                return 'redselect';
            } else if (el.completed === 1) {
                return 'blackselect';
            } else if (el.completed === 9) {
                return 'blackselect';
            }
        },
        /** ----------------------------------------------
         * ローディング開始
         * ---------------------------------------------- */
        loadingOn: function () {
            this.loadingCount++;
            this.$store.commit('loading/setIsLoading', true);
        },
        /** ----------------------------------------------
         * ローディング終了
         * ---------------------------------------------- */
        loadingOff: function () {
            this.loadingCount--;
            if (this.loadingCount === 0) {
                this.$store.commit('loading/setIsLoading', false);
            }
        }
    }
};
</script>

<style scoped>
.point_select {
  color: black;
  background: Transparent;
  text-decoration: underline;
}

.selectWidth {
    width: 195px;
}

.blackselect {
  color: black;
  background: Transparent;
}
.redselect {
  color: red;
  background-color: Transparent;
}
.status_radio{
    padding-right: 2.0rem;
}

</style>
